export {accountRoleOptions} from 'utils/accountRoles';

export function writesAccountRoles(item) {
  if (item._id === 'new_user') return true;
  const previous = item.expectedAccountRoles || [];
  const selected = item.accountRoles || [];
  return (
    selected.length !== previous.length ||
    selected.some((title) => !previous.includes(title))
  );
}
